import { REQUIRED_CONTENT } from '../../_constants';

export const filterEmptyCatalogFolders = (folders) => {
  if (!Array.isArray(folders) || !folders) return [];
  return folders.filter(({ fields }) => REQUIRED_CONTENT.some((field) => Object.keys(fields).includes(field)));
};
